import { currency, numberToFormatted, validateTextWithHypen, } from '@/utils';
import { formatPhoneNumber } from '@/utils/regularExpression';
export default class AdjustmentWorker {
    _code;
    _name;
    _realName;
    _telNumber;
    _employer;
    _workerEmail;
    _salaryType;
    _finishCount;
    _finishCharge;
    constructor({ code, name, 
    // realName,
    telNumber, 
    // employer,
    // workerEmail,
    salaryType, finishCount, finishCharge, }) {
        this._code = code;
        this._name = name;
        // this._realName = realName;
        this._telNumber = telNumber;
        // this._employer = employer;
        // this._workerEmail = workerEmail;
        this._salaryType = salaryType;
        this._finishCount = finishCount;
        this._finishCharge = finishCharge;
    }
    get code() {
        return this._code;
    }
    // 라이더명
    get name() {
        return validateTextWithHypen(this._name);
    }
    // 실명
    get realName() {
        return validateTextWithHypen(this._realName);
    }
    // 라이더번호
    get telNumber() {
        return formatPhoneNumber(this._telNumber);
    }
    // 소속
    get employer() {
        return validateTextWithHypen(this._employer);
    }
    // 이메일
    get workerEmail() {
        return validateTextWithHypen(this._workerEmail);
    }
    // 보수지급방식
    get salaryType() {
        return validateTextWithHypen(this._salaryType);
    }
    // 완료 건수
    get finishCount() {
        return numberToFormatted(this._finishCount);
    }
    // 지급총액
    get finishCharge() {
        return currency(this._finishCharge);
    }
}
